import React from 'react';
import { getVideoId } from '../../shared/getVideoId';
import './Video.scss';

export interface VideoInputs {
    videoUrl?: string;
    title?: string;
    caption?: string;
    name?: string;
}

export const Video = ({ inputs }: { inputs: VideoInputs }) => {
    // parse out the video id
    if (!inputs.videoUrl) {
        return <p>No video.</p>;
    }
    const videoId = getVideoId(inputs.videoUrl);

    return (
        <section className="kite-container paragraph__video">
            {inputs.title && (
                <h2 className="typestack-title-3">{inputs.title}</h2>
            )}
            <div className="video-wrapper">
                <iframe
                    width="854"
                    height="480"
                    src={`https://www.youtube.com/embed/${videoId}?enablejsapi=1`}
                    title={inputs.name ?? `YouTube video player`}
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                />
            </div>
            {inputs.caption && <p className="caption">{inputs.caption}</p>}
        </section>
    );
};
